import { useState } from 'react';

import Header from './naviMenu/Header';
import DrawerSideBar from './naviMenu/DrawerSideBar';
import NavigateBar from './naviMenu/NavigateBar';

const Navbar = () => {
  // state
  const [mobileOpen, setMobileOpen] = useState(false);

  // method
  const handleDrawerToggle = () => {
    setMobileOpen((prev) => !prev);
  };

  return (
    <>
      {/* 헤더 */}
      <Header handleDrawerToggle={handleDrawerToggle} />

      {/* 햄버거 */}
      <DrawerSideBar mobileOpen={mobileOpen} handleDrawerToggle={handleDrawerToggle} />

      {/* 좌측 네비게이션 바 */}
      <NavigateBar />
    </>
  );
};

export default Navbar;
